<img class="logo-image" src="assets/icons/aimo-logo.svg" />